import { faMp3Player } from '@fortawesome/pro-light-svg-icons/faMp3Player';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faBooks } from '@fortawesome/pro-light-svg-icons/faBooks';
import { faFileUser } from '@fortawesome/pro-light-svg-icons/faFileUser';
import { faGlobeEurope } from '@fortawesome/pro-light-svg-icons/faGlobeEurope';
import { faCitrusSlice } from '@fortawesome/pro-light-svg-icons/faCitrusSlice';
import { faHeadset } from '@fortawesome/pro-light-svg-icons/faHeadset';
import { faChartSimple } from '@fortawesome/pro-light-svg-icons/faChartSimple';
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons/faFacebookSquare';
import { faFrame } from '@fortawesome/pro-light-svg-icons/faFrame';
import { faBrush } from '@fortawesome/pro-light-svg-icons/faBrush';
import { faRectangleAd } from '@fortawesome/pro-light-svg-icons/faRectangleAd';
import { faEyeSlash } from '@fortawesome/pro-light-svg-icons/faEyeSlash';
import { faFaceAwesome } from '@fortawesome/pro-light-svg-icons/faFaceAwesome';
import { TranslatableMessage } from '../../../../components/types';

export interface PremiumFeatures {
  label: TranslatableMessage;
  icon: IconDefinition;
}

export const premiumLimits: PremiumFeatures[] = [
  {
    label: {
      id: 'sml.web.premium-features.smartlinks',
      defaultMessage: 'Create up to {smartLinksLimits} smartlinks'
    },
    icon: faBooks
  },
  {
    label: {
      id: 'sml.web.premium-features.accounts',
      defaultMessage: 'Manage {accountsLimits} accounts'
    },
    icon: faFileUser
  }
];

export const premiumFeaturesBasic: PremiumFeatures[] = [
  {
    label: {
      id: 'sml.web.premium-features.subdomain',
      defaultMessage: 'Custom fym.fm short subdomain'
    },
    icon: faCitrusSlice
  },
  {
    label: {
      id: 'sml.web.premium-features.support',
      defaultMessage: 'Email support'
    },
    icon: faHeadset
  },
  {
    label: {
      id: 'sml.web.premium-features.customization',
      defaultMessage: 'Change themes, colors and fonts'
    },
    icon: faBrush
  },
  ...premiumLimits
];

export const premiumFeaturesInfluencer: PremiumFeatures[] = [
  ...premiumFeaturesBasic,
  {
    label: {
      id: 'sml.web.premium-features.own-domain',
      defaultMessage: 'Bring your own domain'
    },
    icon: faGlobeEurope
  },
  {
    label: {
      id: 'sml.web.premium-features.analytics',
      defaultMessage: 'Actionable Analytics'
    },
    icon: faChartSimple
  },
  {
    label: {
      id: 'sml.web.premium-features.custom-targeting',
      defaultMessage: 'Retargeting (FB Pixel, GTag)'
    },
    icon: faFacebookSquare
  },
  {
    label: {
      id: 'sml.web.premium-features.emdedding',
      defaultMessage: 'Embed your SmartLinks anywhere'
    },
    icon: faFrame
  },
  {
    label: {
      id: 'sml.web.premium-features.music-player',
      defaultMessage: 'Use Music Player to promote your singles, albums & playlists'
    },
    icon: faMp3Player
  },
  {
    label: {
      id: 'sml.web.premium-features.fym',
      defaultMessage: 'Free <fym>FreeYourMusic.com</fym> license'
    },
    icon: faFaceAwesome
  }
];

export const premiumFeaturesArtist: PremiumFeatures[] = [
  ...premiumFeaturesInfluencer,
  {
    label: {
      id: 'sml.web.premium-features.promotion',
      defaultMessage: 'Let us promote you!'
    },
    icon: faRectangleAd
  },
  {
    label: {
      id: 'sml.web.premium-features.promotion',
      defaultMessage: 'White-label: hide our logo'
    },
    icon: faEyeSlash
  }
];
